import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'
import {Button} from './core/button.js'


export default class RenderOutro extends React.Component{
	render(){
		const {
			pvEndData,
			sendData,
			lang,
			returnHandler
		} = this.props

		const outroData = pvEndData.screen_2
		const headline = outroData.text_1
		let text = outroData.text_2.do_not_save_data
		let subtext = outroData.text_3

		if(sendData){
			text = outroData.text_2.save_data
		}
		return(
			<CSSTransitionGroup
				transitionName="pv-background"
				transitionAppear={true}
				transitionAppearTimeout={1000}
				transitionEnterTimeout={1000}
				transitionLeaveTimeout={1000}>
				<div className='pv pv-outro'>
					<div className='text'>Danke fürs mitspielen.</div>
					<div className='subtext'>Es gibt also Merkmale, die eine wichtige Rolle für Deine Figur sind. Was denkst Du darüber? Was war neu? Vielleicht kannst Du Dich mit Deiner Familie und Freunden darüber unterhalten. Oder gleich nochmal?</div>
					<Button 
						className={'bottomButton button'}
						name={'Nochmal'}
						handler={returnHandler}
					/>
				</div>
			</CSSTransitionGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/finalScreen.js